import { NewSchema } from "./NewSchema";
import { Schema } from "./Schema";

//表达式一些公共实体

/**
 * 高级表达式语法校验返回值
 * @property closeable 表达式编辑器是否可关闭
 * @properry expression 表达式文本
 * @property semantic 语义化文本
 * @date 2022-08-02 上午10:00
 */
export class AdvancedCheckResult {
  closeable: boolean = false;
  expression: string;
  semantic: string;
}

/**
 * 表达式上下文
 * @property expr 计算表达式文本
 * @property sexpr 简易表达式文本
 * @property sessionEntities 会话变量
 * @property contextEntities 上下文变量
 * @property funcEntities 扩展函数
 * @property schemaMap 旧版Schema数据模型Map
 * @property newSchemaMap 新版NewSchema数据模型Map
 * @property injectedEntities 注入实体，决定展示哪个数据模型
 * @property smartHelpEntities 注入帮助
 */
export class ExpressionContextEntity {
  expr: string = null;
  sexpr: string = "";
  sessionEntities: VarEntity[] = [];
  contextEntities: VarEntity[] = [];
  functionEntities: FunctionEntity[] = [];
  schemaMap = new Map<string, Schema>();
  newSchemaMap = new Map<string, NewSchema>();
  injectedEntities: InjectedEntity[] = [];
  smartHelpEntities: SmartHelpInfo[] = [];
}

/**
 * 定制的计算表达式页面
 * @param Function_ShowExtend 是否展示扩展函数
 * @param DataModel_ShowChildSymbol 是否展示子表[0]，默认展示
 * @param DataArea_DefaultSelect 数据区域的选中tab页，默认为数据模型
 * @param DataArea_Variable_Context 上下文变量设置（null代表无特殊设置；数组代表展示的变量，元素为变量名称）
 * @param DataArea_Variable_Session 会话变量设置（null代表无特殊设置；数组代表展示的变量，元素为变量名称）
 */
export class CustomizedSetting {
  Function_ShowExtend: boolean = true;
  Function_ShowExtendItems: any = null;
  DataModel_ShowChildSymbol: boolean = true;
  DataArea_DefaultSelect: DataArea = DataArea.DataModel;
  DataArea_Variable_Items: any = null;
  DataArea_Variable_Context: any = null;
  DataArea_Variable_Session: any = null;

  static from(copy: any) {
    if (copy != null) {
      if (copy.Function_ShowExtend == null) copy.Function_ShowExtend = true;
      if (copy.Function_ShowExtendItems == null) copy.Function_ShowExtendItems = null;
      if (copy.DataModel_ShowChildSymbol == null) copy.DataModel_ShowChildSymbol = true;
      if (copy.DataArea_DefaultSelect == null) copy.DataArea_DefaultSelect = DataArea.DataModel;
      if (copy.DataArea_Variable_Items == null) copy.DataArea_Variable_Items = null;
      if (copy.DataArea_Variable_Context == null) copy.DataArea_Variable_Context = null;
      if (copy.DataArea_Variable_Session == null) copy.DataArea_Variable_Session = null;
    }

    return copy;
  }
}

/**
 * 表达式模型&变量信息
 * @property properties 数据模型字段
 * @property contextVariables 上下文变量
 * @property sessionVariables 会话变量
 */
export class ExpressionModelDetail {
  // 数据模型字段
  properties: Array<{ code: any, name: any, type: any }> = [];
  // 上下文变量
  contextVariables: Array<{ code: any, name: any }> = [];
  // 会话变量
  sessionVariables: Array<{ code: any, name: any }> = [];

  // errors: any[] = [];
}

/**
 * 数据区域tab页
 * @param DataModel 数据模型
 * @param Variable 变量
 * @param Help 帮助
 */
export enum DataArea {
  DataModel = "DataModel",
  Variable = "Variable",
  Help = "Help"
}

/**
 * 表达式返回值
 * @property expr 计算表达式结果字符串
 * @property sexpr 简单表达式结果字符串，高级表达式不用
 */
export class ExpressionEntity {
  expr: string; //表达式串
  sexpr: string;//简单表达式结构串
}

/**
 * 表达式打开模式
 * @enum Conditional  简易表达式
 * @enum Advanced     计算表达式
 */
export enum ExprEditMode {
  Conditional,
  Advanced
}
//#######################注入实体#######################
/** 
 * 注入实体（决定展示哪个数据模型）
 * @property name 自定义模型根节点名，可不填
 * @property schemaName 决定展示哪个数据模型，为方法addSchema/addNewSchema第一个参数
 * @property injectedType 注入对象类型(EntitySet,EntityType)
 * @property injectedName 注入实体的名称，对应EntityType.code/EntitySet.code
 */
export class InjectedEntity {
  name: string;
  schemaName: string;
  injectedType: InjectedType;
  injectedName: string;
}
/** 
 * 注入对象类型
 * @member EntitySet 实体集
 * @member EntityType 实体类型
 */
export enum InjectedType {
  EntitySet,
  EntityType,
  //新增
  EntityEnum,
  EntityType_ChildTable
}
//#######################变量实体#######################
/**
 * 变量实体，用于会话变量、上下文变量构造
 * @property key 变量key（唯一标识，不可重复）
 * @property name 变量名称
 * @property description 变量描述
 */
export class VarEntity {
  key: string;
  name: string;
  description: string;
}
//#######################帮助实体#######################
export class CurrentNode {
  id: string;
  code: string;
  name: string;
  nodeType: any;
}

export class SmartHelpInfo {
  code: string;
  name: string;
  description: string;
  instance: SmartHelp;
}
export interface SmartHelp {
  //展示帮助并接受返回数据
  show(): Promise<any>;
}
//#######################函数实体#######################
/**
 * 函数实体
 * @property key 扩展函数所在Java类中的函数名（唯一标识，不可重复）
 * @property name 函数名称
 * @property type 函数类型
 * @property description 函数描述
 * @property params 函数参数列表
 * @property keyFront 函数前缀（扩展函数所在Java类名）
 * @property className 类路径（扩展函数所在Java类全限定类名）
 * @property isLatestExtendFunc 是否新型扩展函数
 */
export class FunctionEntity {
  key: string;
  name: string;
  type: any;
  description: string;
  params: Parameter[] = [];
  keyFront: string;
  className: string;
  isLatestExtendFunc: boolean = null;
}
/** 
 * 函数类型
 * @member Advanced 高级
 * @member Analytical 子表
 * @member DateTime 日期时间
 * @member Math 数字
 * @member String 字符串
 * @member Translate 转换
 * @member Extend 扩展
 */
export enum FuncType {
  Advanced = "Advanced",      //高级
  Analytical = "Analytical",  //子表
  DateTime = "DateTime",      //日期时间
  Math = "Math",              //数字
  String = "String",          //字符
  Translate = "Translate",    //转换
  Extend = "Extend",          //扩展
}
/** 
 * 参数信息
 * @param key 某一函数中参数的唯一标识，key取值应有实际意义
 * @property name 参数语义化名
 * @property type 参数类型
 */
export class Parameter {
  key: string;
  name: string;
  type: any;
}
//#######################旧版函数实体#######################
/** 
 * 函数实体列表
 * @deprecated
 * @property funcs 函数实体列表
 */
export class FuncEntities {
  funcs: FuncEntity[] = [];
}
/** 
 * 函数实体
 * @deprecated
 * @property key 函数key值（唯一标识，不可重复）
 * @property name 函数名称
 * @property type 函数类型
 * @property description 函数描述
 * @property params 函数参数列表
 * @property className 所在类名（扩展函数所在Java类全限定类名）
 */
export class FuncEntity {
  key: string;
  name: string;
  type: FuncType;
  description: string;
  params: Parameter[] = [];
  className: string = "";
}
//##########################################################
/**
 * 新型扩展函数实体
 * @property token 扩展函数唯一标识（唯一标识，不可重复）
 * @property key 若为新型扩展函数,此字段失效
 * @property name 函数名称
 * @property type 设置为FuncType.Extend
 * @property description 函数描述
 * @property params 函数参数列表
 * @property keyFront 若为新型扩展函数,此字段失效
 * @property className 若为新型扩展函数,此字段失效
 * @property isLatestExtendFunc 是否新型扩展函数
 */
export class ExtendFunction {
  token: string;
  key: string;
  name: string;
  type: any;
  description: string;
  params: Parameter[] = [];
  keyFront: string;
  className: string;
  isLatestExtendFunc: boolean = null;
}